<template>
    <!-- Theme one -->
    <div v-if="themeStore.themeIndex === 1">
        <BackgroundRechargeOne ref="backgroundRechargeRef" @reset-show-treasure-popup="resetShowTreasurePopup"
            @get-claim="getClaim" />
    </div>

    <!-- theme two -->
    <div v-if="themeStore.themeIndex === 2">
        <BackgroundRechargeTwo ref="backgroundRechargeRef" @get-claim="getClaim" @get-deposit-claim="() => emits('getDepositClaim')"
            @reset-show-treasure-popup="resetShowTreasurePopup"  />
    </div>
    <div v-if="themeStore.themeIndex === 3">
        <BackgroundRechargeThree ref="backgroundRechargeRef" @get-claim="getClaim" @get-deposit-claim="() => emits('getDepositClaim')"
            @reset-show-treasure-popup="resetShowTreasurePopup"  />
    </div>
    <!-- theme four -->
    <div v-if="themeStore.themeIndex === 4">
        <BackgroundRechargeFour ref="backgroundRechargeRef" @get-claim="getClaim" @get-deposit-claim="() => emits('getDepositClaim')"
            @reset-show-treasure-popup="resetShowTreasurePopup"  />
    </div>
    <LoadingScreen ref="loadingRef" />
    <StatusPopup ref="statusRef" :is-show-success="isSuccess" :content="toastContent" />
</template>

<script setup lang="ts">
import { defineEmits, defineExpose, ref } from 'vue';
import { useThemeStore } from '@/stores/theme';
import BackgroundRechargeOne from '@/themes/themeOne/backgroundRecharge/backgroundRecharge.vue';
import BackgroundRechargeTwo from '@/themes/themeTwo/backgroundRecharge/backgroundRecharge.vue';
import BackgroundRechargeThree from '@/themes/themeThree/backgroundRecharge/backgroundRecharge.vue';
import BackgroundRechargeFour from '@/themes/themeFour/backgroundRecharge/backgroundRecharge.vue';
import { backendRechargeClaim } from '@/api/home';
import { useUserStore } from '@/stores/user';
import LoadingScreen from '@/components/common/loadingScreen.vue';
import StatusPopup from '@/components/common/statusPopup.vue';
const themeStore = useThemeStore()
const userStore = useUserStore()
const backgroundRechargeRef = ref()
const isSuccess = ref(false)
const statusRef = ref()
const toastContent = ref('')
const loadingRef = ref()
const emits = defineEmits(['getDepositClaim', 'resetShowTreasurePopup'])

const resetShowTreasurePopup = () => {
    emits('resetShowTreasurePopup')
}
const showError = (msg: string) => {
    toastContent.value = msg
    isSuccess.value = false
    statusRef.value.open()
}
const showSuccess = (msg: string) => {
    toastContent.value = msg
    isSuccess.value = true
    statusRef.value.open()
}
const openPopup = () => {
    backgroundRechargeRef.value.open()
}
const getClaim = async () => {
    loadingRef.value.open()
    let payload = {
        batchRechargeId: userStore.pendingBackendRecharge?.id
    }
    const data = await backendRechargeClaim(payload)
    loadingRef.value.close()
    if (data.code === 200) {
        showSuccess(data.msg)
        backgroundRechargeRef.value.directClose()
    } else {
        showError(data.msg)
    }
    setTimeout(() => {
        userStore.getInfo()
    }, 1500)
}

defineExpose({ openPopup })
</script>
